define.alias("shared/components/shared/wizards/carousel/step-one", "preview-grid/components/shared/wizards/carousel/step-one");